import React from 'react';
import Register from './Register';
import ThemeErrorBoundary from '../../theme/ThemeErrorBoundary';
import { StyledComponentsIntegration } from '../../theme/StyledComponentsIntegration';

/**
 * RegisterWrapper
 * 
 * This component wraps the Register component with the StyledComponentsIntegration
 * to ensure that styled-components has access to the theme.
 */
const RegisterWrapper: React.FC = () => {
  return (
    <ThemeErrorBoundary>
      <StyledComponentsIntegration>
        <Register />
      </StyledComponentsIntegration>
    </ThemeErrorBoundary>
  );
};

export default RegisterWrapper;